import type { BaseTranslation } from '../i18n-types';

export const paymentDetails = {
    taxTitle: 'Tax information',
    countryLabel: 'Country of tax residence',
    countryPlaceholder: 'Country of tax residence',
    countryDescription: 'Country where you live permanently or spend more than 183 days a year',
    countryError: 'Please select your country of tax residence',
    cityLabel: 'City',
    cityError: 'Please specify your city of residence',
    addressLabel: 'Address',
    addressPlaceholder: 'Street, Buildin, Apartment number, Zip Code',
    tinLabel: 'Taxpayer Identification Number&nbsp;(TIN)',
    tinCheckboxLabel: 'I don’t have TIN',
    tinError: 'Please fill in your TIN or note that you don’t have one',
    birthPlaceLabel: 'Your place of birth',
    birthPlacePlaceholder: 'Country, Region and City',
    birthPlaceError: 'Please fill your place of birth',
    vatLabel: 'VAT number',
    vatDescription: 'Fill it out if you are a VAT payer',
    vatHint:
        'This is the unique number that identifies a taxable person (business) or non-taxable legal entity that is registered for VAT. VAT number must begin with the code of the country concerned and followed by a block of digits or characters.',
    navigation: 'Payment details',
    title: 'Payment account details',
    paymentMethodTitle: 'Please specify your preferred payment method',
    paymentMethodLabel: 'Payment method',
    paymentMethodPlaceholder: 'Choose payment method',
    paymentMethodInvalidEdit: 'Edit payment details',
    paymentMethodError: 'Please choose payment method',
    paxumLabel: 'Your Paxum account email',
    paxumFee: 'Fee: $1 per transaction',
    bitcoinFee: 'Fee: 1% per transaction',
    paxumHint: 'Please ensure that the Paxum account is verified',
    usdtFee: 'Fee: 4.5 USDT per transaction',
    usdtLabel: 'Wallet address',
    updatedInfo:
        'Updated payment method will be applied to the next payout (next Monday at 0:00 AM UTC)',
    paymentMethodMore: 'More payment methods are coming soon',
    bitcoinError: 'Address should start with 1, 3 or bc1 and length should be from {minLength:number} up to {maxLength:number}.',
    usdtError: 'Address should start with "T" and length must be {length:number} chars.',
    agreementLabel: `I hereby confirm that the information provided above, including my address, TIN and/or VAT number, is true and accurate. I also consent to the processing of this information in accordance with the applicable {appName:string} <a class="link" href="{privacyLink}" target="_blank">Privacy Policy</a>`,
    updateAlertText: `<b>Update your payment details</b> to continue getting payouts. Without this you will not be able to receive payments`,
    updateAlertButtonLabel: 'Edit payment details',
    minPayoutLabel: 'Minimum payout',
    minPayoutSepaTip: 'We will convert USD to EUR on the day of payment by <a class="link" href="{link:string}" target="_blank">ECB</a> rate (+1% margine)',
    cosmoFee: 'Fee: $3 + 0,4% per transaction',
    sanLabel: 'SAN',
    sanTip: 'Secure/Secondary Account Number, the 9 or 10 digit number found on the back of the prepaid card.',
    sanError: 'SAN should be a number consisting of 9 or 10 digits',
    sepaFee: 'Fee: $2 per transaction',
    bankDetails: {
        title: 'Bank details',
        ibanLabel: 'IBAN',
        ibanTip: `IBAN or International Bank Account Number is a standard international number up to 34 characters long, including numbers and letters<br><br>You can find your IBAN number in the bank statement or contact the bank's support`,
        ibanPatterError: 'IBAN must be up to 34 characters long, including numbers and letters',
        nameLabel: 'Bank name',
        countryLabel: 'Bank country',
        swiftLabel: 'BIC/Swift',
        swiftTip: `BIC/SWIFT is a standard bank identification code format used to identify banks and financial institutions in the international banking network<br><br>You can find your bank's SWIFT/BIC code in your bank account statements or contact the bank's support`,
        swiftRequiredError: 'The BIC/Swift field is required.',
        swiftLengthError: 'The BIC/Swift code must be 8 or 11 characters long.',
        swiftPatterError: 'The BIC/Swift code must start with 4 letters, followed by 2 letters for the country code, and 2 alphanumeric characters for the location code. If provided, the last 3 characters must be alphanumeric for the branch code.',
        commentLabel: 'Comment',
    },
    success: 'Your payment data was changed',
} satisfies BaseTranslation;
